var map = {
	"./SC-3-delat.jpg": "fea7",
	"./SC-4-delat.jpg": "3946",
	"./TE-Lockup-RGB-BLACK.svg": "3100",
	"./TE-Lockup-RGB-BLUE.svg": "0aea",
	"./TE-Lockup-RGB-WHITE.svg": "9006",
	"./archived.svg": "c8b9",
	"./balance-report-preview.png": "613f",
	"./bb-logo-background.svg": "d2c9",
	"./bb-logo-colored.svg": "76b3",
	"./bb-logo-icon.svg": "0da1",
	"./business board-no-text.svg": "28e6",
	"./business-board-landing.jpg": "b2ab",
	"./calendar-white.svg": "25ae",
	"./calendar.svg": "d71f",
	"./check-mark.svg": "37e8",
	"./close.svg": "2930",
	"./club.png": "5686",
	"./compass.svg": "1066",
	"./course data-no-text.svg": "fd21",
	"./download.svg": "c482",
	"./draft.svg": "692e",
	"./drilldown_help.webp": "f040",
	"./evry-logo-black.png": "cd1f",
	"./git-export.png": "2f0c",
	"./golfoffice-laying.svg": "f1e5",
	"./golfoffice-no-text.svg": "9824",
	"./info.svg": "db39",
	"./li-circle-blue.svg": "3526",
	"./li-circle-error.svg": "e22e",
	"./li-circle-ok.svg": "9eff",
	"./oncourse-no-text.svg": "2630",
	"./onscreen-no-text.svg": "1282",
	"./onservice-no-text.svg": "7a0e",
	"./ontag-logo.png": "085b",
	"./ontag-no-text.svg": "8d8b",
	"./oval-green.svg": "fc78",
	"./oval-grey.svg": "2301",
	"./pdf.svg": "5fe9",
	"./pen.svg": "800f",
	"./phone-blue.svg": "6638",
	"./phone-dark.svg": "a3df",
	"./phone-grey.svg": "4c81",
	"./published.svg": "087d",
	"./sc-3&4p-2022.png": "0eca",
	"./sc-3&4p-2023.jpg": "fd16",
	"./sc-3p-2022.png": "4f2e",
	"./sc-3p-2023-3.png": "4659",
	"./sc-3p-2023.jpg": "c480",
	"./sc-3p-blank.png": "344f",
	"./sc-4p-2022-2.png": "ce81",
	"./sc-4p-2022.jpg": "9229",
	"./sc-4p-2022.png": "5e5e",
	"./sc-4p-2023-2.png": "cc61",
	"./sc-4p-2023-3.png": "3494",
	"./sc-4p-2023.jpg": "6bca",
	"./sc-4p-blank.png": "90a5",
	"./scorecard-1.jpg": "bea1",
	"./scorecard-2.jpg": "43e1",
	"./scorecard-3.jpg": "7c7f",
	"./scorecard-4.jpg": "7d8f",
	"./scorecard-5.jpg": "59f6",
	"./scorecard-6.jpg": "4f76",
	"./scorecard-7.jpg": "ddc7",
	"./scorecard-8.jpg": "ff47",
	"./scorecard-big.jpg": "5e83",
	"./scorecard-clubspecific-example.png": "ebce",
	"./scorecard-example.jpg": "8616",
	"./scorecard-preview.jpg": "a02a",
	"./scorecard-standard.png": "edb0",
	"./tag_back.svg": "7f79",
	"./tag_black_oval.svg": "a011",
	"./tag_black_pin.svg": "84cc",
	"./tag_blank_back.svg": "15aa",
	"./tag_blank_center.svg": "aea0",
	"./tag_blank_front.svg": "1a5c",
	"./tag_blue_oval.svg": "033a",
	"./tag_blue_pin.svg": "7ac6",
	"./tag_center.svg": "cc0a",
	"./tag_front.svg": "8114",
	"./tag_green_oval.svg": "7702",
	"./tag_green_pin.svg": "ffd6",
	"./tag_hand.svg": "bacb",
	"./tietoevry-logo-neutral-cmyk_M.svg": "5662",
	"./to do-no-text.svg": "2c87",
	"./voucher-bg.svg": "4391",
	"./voucher-edit-bg.png": "b821",
	"./voucher-icon_blue.svg": "fd56",
	"./voucher-icon_grey.svg": "5216",
	"./voucher-list-bg.png": "1f94",
	"./wave-background.svg": "73d5",
	"./zoom.svg": "29d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";